module.exports = __webpack_public_path__ + "static/Logo.7ef83fd5.svg";


//////////////////
// WEBPACK FOOTER
// D:/Workarea/iota.org/documentation/src/assets/Logo.svg
// module id = 154
// module chunks = 0 1 2 3